import { Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AuthorEvaluationWizard } from '@/module/Evaluation/AuthorEvaluationWizard';
import { getEvaluationCriteriaOptions, getEvaluationOptions } from '@/module/Evaluation/model/EvaluationQuery';

export const Route = createFileRoute(
  '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { evaluationId, orderNo } = Route.useParams();
  const { data: evaluation } = useSuspenseQuery(getEvaluationOptions(evaluationId));
  const { data: criteria } = useSuspenseQuery(getEvaluationCriteriaOptions(evaluationId));
  const index = criteria.map(c => c.orderNo).indexOf(Number(orderNo));
  const template = criteria[index];

  const userId = Route.useSearch().userId;

  return (
    <>
      {userId != null && (
        <AuthorEvaluationWizard
          key={`${evaluationId}-${orderNo}-${userId}`}
          evaluationId={evaluationId}
          template={template}
          authorId={userId}
          isEvaluationClosed={!evaluation.open}
        />
      )}
      {userId == null && <Text>Utilizator neselectat</Text>}
    </>
  );
}
